import DetailSkeleton from "@/components/SkeletonLoader/DetailSkeleton";
import useParlorDetail from "@/hooks/useParlorDetailByType";
import { estimateLoadingState } from "@/atoms/parlors/estimateState";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import Funeral from "@/components/Parlor/Funeral/Funeral";
import { VStack } from "goi_common";

function ParlorPriceTypeContainer({ parlorId, type }: { parlorId: string; type: string }) {
  const setEstimateLoading = useSetRecoilState(estimateLoadingState);
  const { parlor, parlorRevalidate } = useParlorDetail({ parlorId, type });

  useEffect(() => {
    parlorRevalidate().then(() => {
      setEstimateLoading(false);
    });
  }, [parlorRevalidate, setEstimateLoading, parlorId, type]);

  if (!parlor)
    return (
      <VStack width="100%" alignItems="center">
        <VStack maxWidth="720px" width="100%">
          <DetailSkeleton />
        </VStack>
      </VStack>
    );

  return <Funeral parlor={parlor} />;
}

export default ParlorPriceTypeContainer;
